module.exports = __webpack_public_path__ + "img/logo-gdp.0fe10e1.png";